import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import SettingsIcon from "@mui/icons-material/Settings";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import SingularityLogo from "shared/dist/assets/images/avatar.png";
import { selectOrganization } from "../../../Services/Redux/actionCreators/organizationActions";
import { userRoles } from "../../../Utils/user";
import {
    organizationSetupStatusesLable,
    organizationSetupStatuses,
} from "../../../Utils/organizationSetup";
import classes from "./UserPopUp.module.css";
import { useNavigateTo } from "../../../GlobalRouter/hook/NavigateTo";

const OrganizationRaw = ({ orgUuid, orgImg, orgName, orgStatus, orgOwner, closeAndRun }) => {
    const navigateTo = useNavigateTo();
    const { selectedOrganizationUuid, currentUserMail } = useSelector(
        (state) => ({
            selectedOrganizationUuid: state.organization.selectedOrganizationUuid,
            currentUserMail: state.user.email,
        }),
        shallowEqual
    );
    const dispatch = useDispatch();

    const userRole = currentUserMail === orgOwner ? userRoles.OWNER : userRoles.MEMBER;

    const handleEdit = (event) => {
        event.stopPropagation();
        closeAndRun(async () => {
            await dispatch(selectOrganization(orgUuid));
            navigateTo.organizationSetup({ orgUuid });
        });
    };

    const handleSelectOrganization = () => {
        closeAndRun(async () => {
            await dispatch(selectOrganization(orgUuid));
            if (
                orgStatus === organizationSetupStatuses.PUBLISHED ||
                orgStatus === organizationSetupStatuses.PUBLISH_IN_PROGRESS
            ) {
                navigateTo.services({ orgUuid });
            } else {
                navigateTo.organizationSetup({ orgUuid });
            }
        });
    };

    const EditButton = () => {
        return (
            <IconButton onClick={(e) => handleEdit(e)} className={classes.orgEditButton}>
                <SettingsIcon />
            </IconButton>
        );
    };

    const isOrgSelected = selectedOrganizationUuid === orgUuid;

    return (
        <div className={classes.orgNameContainer} onClick={handleSelectOrganization}>
            <Avatar
                aria-label="recipe"
                className={classes.avatar}
                src={orgImg || SingularityLogo}
            />
            <div className={classes.orgNameAndRole}>
                <div className={classes.orgInfo}>
                    <div
                        className={`${classes.orgTitle} ${isOrgSelected && classes.selectedOrganization}`}
                    >
                        {orgName} - {userRole}
                    </div>
                    <div className={classes.orgStatus}>
                        {organizationSetupStatusesLable[orgStatus]}
                    </div>
                </div>
                <div>{userRole === userRoles.OWNER && <EditButton />}</div>
            </div>
        </div>
    );
};

export default OrganizationRaw;
